<footer id="footer">
    <div id="copyright">
        <p>© Todos os direitos reservados</p>
    </div>
</footer>

<style>
#footer {
    padding: 30px;
}

#copyright {
    text-align: center;
}
</style>